/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import IntegerRange from './IntegerRange';
import JobCategory from './JobCategory';
import SearchRange from './SearchRange';

/**
 * The UserSearchRequest model module.
 * @module model/UserSearchRequest
 * @version 1.0.0
 */
class UserSearchRequest {
    /**
     * Constructs a new <code>UserSearchRequest</code>.
     * @alias module:model/UserSearchRequest
     */
    constructor() { 
        
        UserSearchRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>UserSearchRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/UserSearchRequest} obj Optional instance to populate.
     * @return {module:model/UserSearchRequest} The populated <code>UserSearchRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new UserSearchRequest();

            if (data.hasOwnProperty('score')) {
                obj['score'] = ApiClient.convertToType(data['score'], ['Number']);
            }
            if (data.hasOwnProperty('age')) {
                obj['age'] = IntegerRange.constructFromObject(data['age']);
            }
            if (data.hasOwnProperty('annual_income')) {
                obj['annual_income'] = IntegerRange.constructFromObject(data['annual_income']);
            }
            if (data.hasOwnProperty('job_category')) {
                obj['job_category'] = JobCategory.constructFromObject(data['job_category']);
            }
            if (data.hasOwnProperty('job_continuous_year')) {
                obj['job_continuous_year'] = ApiClient.convertToType(data['job_continuous_year'], 'Number');
            }
            if (data.hasOwnProperty('use_estimated_job_continuous_period')) {
                obj['use_estimated_job_continuous_period'] = ApiClient.convertToType(data['use_estimated_job_continuous_period'], 'Boolean');
            }
            if (data.hasOwnProperty('interested_property_type_ids')) {
                obj['interested_property_type_ids'] = ApiClient.convertToType(data['interested_property_type_ids'], ['Number']);
            }
            if (data.hasOwnProperty('extract_number')) {
                obj['extract_number'] = SearchRange.constructFromObject(data['extract_number']);
            }
            if (data.hasOwnProperty('is_favorite')) {
                obj['is_favorite'] = ApiClient.convertToType(data['is_favorite'], 'Boolean');
            }
            if (data.hasOwnProperty('holding_property_count')) {
                obj['holding_property_count'] = IntegerRange.constructFromObject(data['holding_property_count']);
            }
            if (data.hasOwnProperty('loan_amount')) {
                obj['loan_amount'] = IntegerRange.constructFromObject(data['loan_amount']);
            }
            if (data.hasOwnProperty('loan_amount_income_multiple')) {
                obj['loan_amount_income_multiple'] = ApiClient.convertToType(data['loan_amount_income_multiple'], 'Number');
            }
            if (data.hasOwnProperty('financial_asset')) {
                obj['financial_asset'] = ApiClient.convertToType(data['financial_asset'], ['Number']);
            }
            if (data.hasOwnProperty('days_since_proposal')) {
                obj['days_since_proposal'] = ApiClient.convertToType(data['days_since_proposal'], ['Number']);
            }
            if (data.hasOwnProperty('re_proposal_count')) {
                obj['re_proposal_count'] = ApiClient.convertToType(data['re_proposal_count'], ['Number']);
            }
            if (data.hasOwnProperty('has_other_information')) {
                obj['has_other_information'] = ApiClient.convertToType(data['has_other_information'], 'Boolean');
            }
            if (data.hasOwnProperty('address_prefectures')) {
                obj['address_prefectures'] = ApiClient.convertToType(data['address_prefectures'], ['String']);
            }
            if (data.hasOwnProperty('job_industry_ids')) {
                obj['job_industry_ids'] = ApiClient.convertToType(data['job_industry_ids'], ['Number']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>UserSearchRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>UserSearchRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is an array
        if (!Array.isArray(data['score'])) {
            throw new Error("Expected the field `score` to be an array in the JSON data but got " + data['score']);
        }
        // validate the optional field `age`
        if (data['age']) { // data not null
          IntegerRange.validateJSON(data['age']);
        }
        // validate the optional field `annual_income`
        if (data['annual_income']) { // data not null
          IntegerRange.validateJSON(data['annual_income']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['interested_property_type_ids'])) {
            throw new Error("Expected the field `interested_property_type_ids` to be an array in the JSON data but got " + data['interested_property_type_ids']);
        }
        // validate the optional field `extract_number`
        if (data['extract_number']) { // data not null
          SearchRange.validateJSON(data['extract_number']);
        }
        // validate the optional field `holding_property_count`
        if (data['holding_property_count']) { // data not null
          IntegerRange.validateJSON(data['holding_property_count']);
        }
        // validate the optional field `loan_amount`
        if (data['loan_amount']) { // data not null
          IntegerRange.validateJSON(data['loan_amount']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['financial_asset'])) {
            throw new Error("Expected the field `financial_asset` to be an array in the JSON data but got " + data['financial_asset']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['days_since_proposal'])) {
            throw new Error("Expected the field `days_since_proposal` to be an array in the JSON data but got " + data['days_since_proposal']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['re_proposal_count'])) {
            throw new Error("Expected the field `re_proposal_count` to be an array in the JSON data but got " + data['re_proposal_count']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['address_prefectures'])) {
            throw new Error("Expected the field `address_prefectures` to be an array in the JSON data but got " + data['address_prefectures']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['job_industry_ids'])) {
            throw new Error("Expected the field `job_industry_ids` to be an array in the JSON data but got " + data['job_industry_ids']);
        }

        return true;
    }


}



/**
 * スコア絞り込み（[1..5]）。未設定のみは [null]
 * @member {Array.<Number>} score
 */
UserSearchRequest.prototype['score'] = undefined;

/**
 * @member {module:model/IntegerRange} age
 */
UserSearchRequest.prototype['age'] = undefined;

/**
 * @member {module:model/IntegerRange} annual_income
 */
UserSearchRequest.prototype['annual_income'] = undefined;

/**
 * @member {module:model/JobCategory} job_category
 */
UserSearchRequest.prototype['job_category'] = undefined;

/**
 * 勤続年数
 * @member {Number} job_continuous_year
 */
UserSearchRequest.prototype['job_continuous_year'] = undefined;

/**
 * true の場合、登録後の経過期間を加味した推定勤続年数カテゴリで検索
 * @member {Boolean} use_estimated_job_continuous_period
 */
UserSearchRequest.prototype['use_estimated_job_continuous_period'] = undefined;

/**
 * 興味のある物件タイプID。0 は「未選択（興味未設定ユーザー）」を表すsentinelで、他IDとのOR検索に利用する
 * @member {Array.<Number>} interested_property_type_ids
 */
UserSearchRequest.prototype['interested_property_type_ids'] = undefined;

/**
 * @member {module:model/SearchRange} extract_number
 */
UserSearchRequest.prototype['extract_number'] = undefined;

/**
 * @member {Boolean} is_favorite
 */
UserSearchRequest.prototype['is_favorite'] = undefined;

/**
 * @member {module:model/IntegerRange} holding_property_count
 */
UserSearchRequest.prototype['holding_property_count'] = undefined;

/**
 * @member {module:model/IntegerRange} loan_amount
 */
UserSearchRequest.prototype['loan_amount'] = undefined;

/**
 * 借入額の年収倍率の上限。借入残高（住宅ローン残高＋不動産投資ローン残高）≦ 年収 × 本値 で絞り込む
 * @member {module:model/UserSearchRequest.LoanAmountIncomeMultipleEnum} loan_amount_income_multiple
 */
UserSearchRequest.prototype['loan_amount_income_multiple'] = undefined;

/**
 * 金融資産
 * @member {Array.<module:model/UserSearchRequest.FinancialAssetEnum>} financial_asset
 */
UserSearchRequest.prototype['financial_asset'] = undefined;

/**
 * 提案からの経過日数（配列で複数指定可能）
 * @member {Array.<module:model/UserSearchRequest.DaysSinceProposalEnum>} days_since_proposal
 */
UserSearchRequest.prototype['days_since_proposal'] = undefined;

/**
 * 再提案回数によるフィルタ（6は6〜9回、10は10回以上を表す）
 * @member {Array.<module:model/UserSearchRequest.ReProposalCountEnum>} re_proposal_count
 */
UserSearchRequest.prototype['re_proposal_count'] = undefined;

/**
 * コメントがあるユーザーのみを絞り込む
 * @member {Boolean} has_other_information
 */
UserSearchRequest.prototype['has_other_information'] = undefined;

/**
 * 居住地（都道府県名の配列）
 * @member {Array.<String>} address_prefectures
 */
UserSearchRequest.prototype['address_prefectures'] = undefined;

/**
 * 業種IDs（複数指定可能）
 * @member {Array.<Number>} job_industry_ids
 */
UserSearchRequest.prototype['job_industry_ids'] = undefined;





/**
 * Allowed values for the <code>loan_amount_income_multiple</code> property.
 * @enum {Number}
 * @readonly
 */
UserSearchRequest['LoanAmountIncomeMultipleEnum'] = {

    /**
     * value: 4
     * @const
     */
    "4": 4,

    /**
     * value: 6
     * @const
     */
    "6": 6,

    /**
     * value: 8
     * @const
     */
    "8": 8,

    /**
     * value: 10
     * @const
     */
    "10": 10,

    /**
     * value: 12
     * @const
     */
    "12": 12,

    /**
     * value: 14
     * @const
     */
    "14": 14,

    /**
     * value: 16
     * @const
     */
    "16": 16,

    /**
     * value: 18
     * @const
     */
    "18": 18,

    /**
     * value: 20
     * @const
     */
    "20": 20,

    /**
     * value: 25
     * @const
     */
    "25": 25
};


/**
 * Allowed values for the <code>financialAsset</code> property.
 * @enum {Number}
 * @readonly
 */
UserSearchRequest['FinancialAssetEnum'] = {

    /**
     * value: 1
     * @const
     */
    "1": 1,

    /**
     * value: 2
     * @const
     */
    "2": 2,

    /**
     * value: 3
     * @const
     */
    "3": 3,

    /**
     * value: 4
     * @const
     */
    "4": 4,

    /**
     * value: 5
     * @const
     */
    "5": 5
};


/**
 * Allowed values for the <code>daysSinceProposal</code> property.
 * @enum {Number}
 * @readonly
 */
UserSearchRequest['DaysSinceProposalEnum'] = {

    /**
     * value: 1
     * @const
     */
    "1": 1,

    /**
     * value: 2
     * @const
     */
    "2": 2,

    /**
     * value: 3
     * @const
     */
    "3": 3,

    /**
     * value: 4
     * @const
     */
    "4": 4,

    /**
     * value: 5
     * @const
     */
    "5": 5,

    /**
     * value: 6
     * @const
     */
    "6": 6,

    /**
     * value: 7
     * @const
     */
    "7": 7,

    /**
     * value: 8
     * @const
     */
    "8": 8,

    /**
     * value: 9
     * @const
     */
    "9": 9,

    /**
     * value: 10
     * @const
     */
    "10": 10,

    /**
     * value: 1001
     * @const
     */
    "1001": 1001,

    /**
     * value: 1002
     * @const
     */
    "1002": 1002
};


/**
 * Allowed values for the <code>reProposalCount</code> property.
 * @enum {Number}
 * @readonly
 */
UserSearchRequest['ReProposalCountEnum'] = {

    /**
     * value: 0
     * @const
     */
    "0": 0,

    /**
     * value: 1
     * @const
     */
    "1": 1,

    /**
     * value: 2
     * @const
     */
    "2": 2,

    /**
     * value: 3
     * @const
     */
    "3": 3,

    /**
     * value: 4
     * @const
     */
    "4": 4,

    /**
     * value: 5
     * @const
     */
    "5": 5,

    /**
     * value: 6
     * @const
     */
    "6": 6,

    /**
     * value: 10
     * @const
     */
    "10": 10
};



export default UserSearchRequest;

